import type { GutterItem } from '~/types';

const genericKeys = {
  all: ['sdui'],
  withAlert: (selectedAlert: GutterItem) => [
    selectedAlert.ruleCategoryId,
    selectedAlert.ruleSubCategoryId,
    selectedAlert.ruleId,
    selectedAlert.gutterItemId,
  ],
  layouts: () => [...genericKeys.all, 'layout'],
  layout: (selectedAlert: GutterItem) => [
    ...genericKeys.layouts(),
    ...genericKeys.withAlert(selectedAlert),
  ],
  datas: () => [...genericKeys.all, 'data'],
  data: (selectedAlert: GutterItem) => [
    ...genericKeys.datas(),
    ...genericKeys.withAlert(selectedAlert),
  ],
};

export default genericKeys;
